import React from "react";

class Loader extends React.Component {
	render() {
		return (
			<div id="loading" className="section-loading">
				<div className="loading-circles">
					<div className="loading-circle forge" />
					<div className="loading-circle fire" />
					<div className="loading-circle flow" />
				</div>
			</div>
		);
	}
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js